import styled, {css} from 'styled-components'
import {TableBodyCellText} from '@components/ui/table-atoms/TableAtoms.tsx'

export const StyledUsersWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral['white']};
        height: 100%;
        border-radius: 8px 8px 0 0;
        border: 1px solid ${palette.neutral[200]};
    `
)

export const StyledSelectCell = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: ${spacing * 2}px;
        width: 100%;
        padding: ${spacing * 0.5}px;

        & svg {
            fill: ${palette.orange['600']};
        }
    `
)

export const StyledNameCell = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 1.5}px;
        width: 100%;
        color: ${palette.neutral['950']};
    `
)

export const StyledStatusCell = styled(TableBodyCellText)(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        width: 100%;
    `
)
